import styled from 'styled-components';

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50mm;
  margin: 0 auto 2rem;
`;

const ListPaper = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    grid-template-columns: 1fr;
  }
`;

const Overlay = styled.div`
  position: absolute;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  animation: fadeIn 0.3s;
`;

const Paper = styled.div`
  position: relative;
  width: 100%;
  height: 65mm;
  border: 1px solid rgba(0, 0, 0, 0.15);
  overflow: hidden;

  &:hover {
    ${Overlay} {
      display: flex;
      z-index: 1;
      pointer-events: none;

      button {
        pointer-events: auto;
      }
    }
  }
`;

Paper.Content = styled.div`
  height: calc(100% - 3em);
  margin: 2rem;
  overflow: hidden;
  zoom: 0.3;
`;

const Title = styled.h5`
  margin-top: 0.5rem;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
`;

export default { Item, ListPaper, Overlay, Paper, Title };
